import React, { useState } from 'react'
import { Formik } from 'formik';
import VideoForm from './VideoForm'
import { validationVideoForm } from '../../../utils/validations';
import { connect } from 'react-redux';
import { addVideoYoutube } from '../../../store/actions/UserAction'
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import TrophieModal from '../../Modal/TrophieModal';

function AddVideo(props) {

  const { evento, e_target, addVideoYoutube, uid, videosYoutube , snack, elements, showLoading, hideLoading, trophie} = props;

  const [openTrophieModal, setOpenTrophieModal] = useState(false);

  const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  };

  const handleSubmit = (values, { setSubmitting, cFieldError, resetForm  }) => {
    
    const boolValues = true
    
    showLoading();
    evento(false)
    e_target(values.youtube)
    setSubmitting(false);
    addVideoYoutube(values, uid, boolValues).then(res => {
      hideLoading();
      if (boolValues === false || trophie) {
        snack();
      }
      if (boolValues === true && !trophie) {
        handleOpenTrophieModal()
      }
      resetForm()
    }).catch(error => {})

  };

  const formValues = {
    youtube: '',
  };

  const doneTab = (urlVideo) => {
    evento(false)
    e_target(urlVideo)
  }

  const resetTab = () => {
    evento(false)
  }

  return (
    <>
      <div className="addLawyers_marco" >
        <Formik
          initialValues={formValues}
          validationSchema={validationVideoForm}
          onSubmit={handleSubmit}
          render={props => <VideoForm evento={resetTab} done={doneTab} {...props} />}
        />
      </div>

      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title='Costo de servicios'
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Es importante informarle a los clientes sobre los costos de tus asesorías'
      />
    </>
  )
}

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  videosYoutube: state.authClient.videosYoutube,
  trophie: state.authClient.awardAditional.videos,
});

const mapDispatchToProps = dispatch => ({
  addVideoYoutube: (values, uid, boolValues) => dispatch(addVideoYoutube(values, uid, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVideo);